import { cmsApi } from './cms.api';

export const {
  useGetCmsConfigsQuery,
  useGetCmsHelpsQuery,
  useGetCmsArticlesQuery,
  useGetCmsArticleQuery,
  useGetCmsBannersQuery,
  useGetTermsAndConditionsQuery,
  useGetPrivacyPolicyQuery,
  useGetBenefitQuery,
} = cmsApi;
